import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { CompanyConfigService, CompanyConfig } from '../../services/company-config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  imports: [CommonModule, MatIconModule, MatButtonModule]
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  config: CompanyConfig;

  constructor(
    private router: Router,
    private companyConfig: CompanyConfigService
  ) {
    this.config = this.companyConfig.getConfig();
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  sendEmail() {
    this.companyConfig.sendEmail();
  }

  openSocialLink(platform: keyof CompanyConfig['social']) {
    this.companyConfig.openSocialLink(platform);
  }
}